import React from "react";

import "./CardGridContainer.scss";

type CardGridContainerProps = {};

export function CardGridContainer({
    children,
}: React.PropsWithChildren<CardGridContainerProps>) {
    return <section className="card-grid-container">{children}</section>;
}
